module.exports = __webpack_public_path__ + "static/media/mentorship-third.830fb57d.jpg";